"use strict";

exports.__esModule = true;
exports.default = void 0;
var isReactNative = function isReactNative() {
  return typeof navigator !== 'undefined' && typeof navigator.product === 'string' && navigator.product.toLowerCase() === 'reactnative';
};
var _default = exports.default = isReactNative;